export default "__VITE_ASSET__C$bTc01B__"